<template>
  <v-layout d-flex column class="mx-md-12 px-md-12">
    <v-dialog v-model="headerDialog" persistent max-width="75%">
      <v-card>
        <v-card-title>
          <span class="headline">Editar Encabezado</span>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-row">
            <div class="d-flex justify-center flex-grow-1 mx-6">
              <v-file-input
                v-model="photoFile"
                color="bolsa-color-primario"
                label="Foto de Perfil"
                multiple
                accept="image/*"
                placeholder="Selecciona una foto..."
                prepend-icon="mdi-account-circle"
                @change="mockFunc(photoFile)"
              >
                <template v-slot:selection="{ text }">
                  <v-chip color="bolsa-color-primario" dark label small>
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </div>
          </div>
          <div class="d-flex flex-row justify-center">
            <div class="d-flex">
              <v-img
                class="white--text"
                height="150px"
                :src="getBackImageDefault"
                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
                max-width="60vw"
              >
                <div class="text-center">
                  <v-avatar size="110">
                    <img
                      :src="getPhotoUrl"
                      :alt="photoFile ? photoFile[0].name : 'alt'"
                    />
                  </v-avatar>
                </div>
                <v-card-title
                  class="pt-0 align-start justify-center fill-height"
                >
                  {{ userData.nombres }} {{ userData.apellidoPaterno }}
                  {{ userData.apellidoMaterno }}
                </v-card-title>
              </v-img>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="bolsa-color-primario"
            text
            @click="headerDialog = false"
            :disabled="fetching"
            >Cerrar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="bolsa-color-primario"
            dark
            @click="uploadPhoto"
            :loading="fetching"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="reclutadorViewDialog" scrollable max-width="675px">
      <v-card>
        <v-card-title>Perfil Principal</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px">
          <DetalleAlumno :user-data="userData" :modal="true" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-flex class="mx-md-12 px-md-12">
      <v-card class="mx-auto" width="100vw">
        <v-img
          class="white--text d-flex align-center"
          height="175px"
          gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
          max-width="100vw"
          :src="getBackImageDefault"
        >
          <v-hover>
            <template v-slot:default="{ hover }">
              <div class="text-center">
                <v-avatar size="110">
                  <img
                    :src="
                      userData.fotoPerfil
                        ? userData.fotoPerfil
                        : getProfileDefault
                    "
                  />
                </v-avatar>
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute>
                    <div class="d-flex flex-column">
                      <v-btn
                        color="bolsa-guinda"
                        rounded
                        @click="headerDialog = true"
                        class="my-2"
                      >
                        <v-icon left>mdi-pencil</v-icon>Editar Encabezado
                      </v-btn>
                      <v-btn
                        rounded
                        color="primary"
                        class="my-2"
                        @click="reclutadorViewDialog = !reclutadorViewDialog"
                      >
                        <v-icon left>mdi-eye</v-icon>Ver Perfil como Reclutador
                      </v-btn>
                    </div>
                  </v-overlay>
                </v-fade-transition>
              </div>
            </template>
          </v-hover>
          <v-card-title
            class="pt-0 mt-2 align-start justify-center fill-height"
          >
            {{ userData.nombres }} {{ userData.apellidoPaterno }}
            {{ userData.apellidoMaterno }}
          </v-card-title>
        </v-img>

        <v-card-text>
          <v-container
            grid-list-xl
            fluid
            align-content-space-between
            width="100vw"
          >
            <v-layout wrap row justify-space-around align-content-end>
              <v-flex style="width: 50%">
                <div class="text-center">
                  <span>Especialidad:</span>
                  <h2>{{ userData.carrera.nombreEspecialidad }}</h2>
                </div>
              </v-flex>
              <v-flex style="width: 50%">
                <div class="text-center">
                  <span>Ubicación:</span>
                  <h2>{{ userData.ubicacion || 'Lima - Perú' }}</h2>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-container grid-list-xl justify-space-between>
            <v-layout
              wrap
              v-bind="binding"
              justify-space-between
              align-content-center
              align-center
            >
              <v-flex sm12>
                <v-toolbar flat>
                  <template>
                    <v-tabs
                      centered
                      grow
                      show-arrows
                      color="bolsa-green"
                      v-model="model"
                    >
                      <v-tab
                        v-for="(tab, i) in tabs"
                        :key="i"
                        class="ml-0"
                        color
                        :href="`#${tab.name}`"
                        >{{ tab.text }}</v-tab
                      >
                    </v-tabs>
                  </template>
                </v-toolbar>
              </v-flex>
              <!-- <v-flex sm12 md4 id="buttonsProfile" v-if="$vuetify.breakpoint.mdAndUp">
                  <div class="text-center">
                    <v-layout wrap v-bind="binding">
                      <v-flex sm12 md8>
                        <v-overflow-btn
                          :items="dropdown_font"
                          :value="dropdown_font[0]"
                          target="#buttonsProfile"
                        ></v-overflow-btn>
                      </v-flex>
                      <v-flex sm12 md3 :class="{'mt-2': $vuetify.breakpoint.mdAndUp}">
                        <v-menu left offset-y>
                          <template v-slot:activator="{ on: menu }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on: tooltip }">
                                <v-btn dark v-on="{ ...tooltip, ...menu }" fab color="red">
                                  <v-icon>mdi-briefcase-upload</v-icon>
                                </v-btn>
                              </template>
                              <span>Subir Información</span>
                            </v-tooltip>
                          </template>
                          <v-list>
                            <v-list-item-group v-model="item" color="primary">
                              <v-list-item v-for="(item, index) in itemsActions" :key="index">
                                <v-list-item-icon>
                                  <v-icon v-text="item.icon"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </div>
              </v-flex>-->
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex class="pt-0 mx-md-12 px-md-12">
      <v-tabs-items v-model="model">
        <v-tab-item id="tabPerfil">
          <perfil-tab :user-data="userData"></perfil-tab>
        </v-tab-item>

        <v-tab-item id="tabTrabajos">
          <trabajo-tab :user-data="userData"></trabajo-tab>
        </v-tab-item>

        <v-tab-item id="tabIntereses">
          <intereses-tab :user-data="userData"></intereses-tab>
        </v-tab-item>

        <v-tab-item id="tabCompetencias">
          <competencias-tab :user-data="userData"></competencias-tab>
        </v-tab-item>

        <v-tab-item id="tabExperiencia">
          <experiencia-tab :user-data="userData"></experiencia-tab>
        </v-tab-item>

        <v-tab-item id="tabEducacion">
          <educacion-tab :user-data="userData"></educacion-tab>
        </v-tab-item>
      </v-tabs-items>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    PerfilTab: () => import('@/components/user/profile/Perfil.vue'),
    TrabajoTab: () => import('@/components/user/profile/Trabajos.vue'),
    InteresesTab: () => import('@/components/user/profile/Intereses.vue'),
    CompetenciasTab: () => import('@/components/user/profile/Competencias.vue'),
    ExperienciaTab: () => import('@/components/user/profile/Experiencia.vue'),
    EducacionTab: () => import('@/components/user/profile/Educacion.vue'),
    DetalleAlumno: () =>
      import('@/components/company/common/DetallePostulante.vue')
  },
  props: ['userData'],
  data: function () {
    return {
      headerDialog: false,
      model: 'tabPerfil',
      headerDialog: false,
      reclutadorViewDialog: false,
      tabs: [
        { text: 'Perfil', name: 'tabPerfil' },
        { text: 'Mis Trabajos', name: 'tabTrabajos' },
        { text: 'Intereses y Publicaciones', name: 'tabIntereses' },
        { text: 'Competencias', name: 'tabCompetencias' },
        { text: 'Experiencia', name: 'tabExperiencia' },
        { text: 'Educación e Investigación', name: 'tabEducacion' }
      ],
      photoFile: null,
      photoAsUrl: null,
      headerImageFile: null,
      dropdown_font: ['Ver Como Yo', 'Ver Como Reclutador'],
      itemsActions: [
        { text: 'Subir CV', icon: 'mdi-file-upload' },
        { text: 'Conectar con LinkedIn', icon: 'mdi-linkedin-box' }
      ]
    }
  },

  methods: {
    async getFileUrl(data) {
      if (data) {
        return new Promise(function (resolve, reject) {
          const reader = new FileReader()
          reader.onload = () => {
            resolve(reader.result)
          }

          reader.onerror = reject
          reader.readAsDataURL(data)
        })
      } else {
        return 'https://cdn.vuetifyjs.com/images/john.jpg'
      }
    },

    async mockFunc(file) {
      if (file) {
        const resp = await this.getFileUrl(file[0])
        this.photoAsUrl = resp
      } else {
        console.log('inside else')
        return 'https://cdn.vuetifyjs.com/images/john.jpg'
      }
    },

    async uploadPhoto() {
      let response = await this.uploadPhotoUser(this.photoFile[0])
      if (response.success) {
        this.snackbar = true
        this.snackbarStatus = 'Success'
        this.snackbarText = response.message
        await this.getProfileInfo()
        this.headerDialog = false
        this.photoAsUrl = null
        this.photoFile = null
      }
    },

    ...mapActions('user', ['uploadPhotoUser', 'getProfileInfo'])
  },

  computed: {
    binding() {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true
      return binding
    },

    selectedTab() {
      if (this.$route.hash) this.model = this.$route.hash.substring(1)
      return this.model
    },

    getPhotoUrl() {
      return this.photoAsUrl
        ? this.photoAsUrl
        : this.userData.fotoPerfil
        ? this.userData.fotoPerfil
        : this.getProfileDefault
    },

    getBackImageDefault() {
      return require('@/assets/uni.jpg')
    },

    getProfileDefault() {
      return require('@/assets/anonymous.png')
    },

    ...mapGetters('user', ['fetching'])
  }
}
</script>

<style>
</style>